import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getServiceRequests} = api.serviceRequests;

const getServiceRequestsRefresh = atom<number>({
  key: 'getServiceRequestsRefresh',
  default: 0,
});

export const useGetServiceRequestsRefresh = () => {
  const refreshFn = useSetRecoilState(getServiceRequestsRefresh);
  return () => refreshFn((prev) => prev + 1);
};

const getServiceRequestsQuery = selectorFamily({
  key: 'getServiceRequests',
  get(params: Parameters<typeof getServiceRequests>[0]) {
    return async ({get}) => {
      get(getServiceRequestsRefresh);
      try {
        const {data} = await getServiceRequests(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetServiceRequestsQuery = createQuery(getServiceRequestsQuery, getServiceRequestsRefresh);
